import React from 'react'

export default () => (
  <svg
    width="52px"
    height="56px"
    viewBox="0 0 52 56"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    css={`
      position: absolute;
      left: -21px;
      top: -26px;
      transition: transform 200ms ease;

      &:hover {
        transform: rotate(720deg);
      }
    `}
  >
    <g
      transform="translate(-177.000000, -152.000000) translate(204.500000, 180.500000) rotate(-13.000000) translate(-204.500000, -180.500000) translate(181.000000, 157.000000)"
      fillRule="nonzero"
      stroke="none"
      strokeWidth={1}
      fill="none"
    >
      <g transform="translate(1.000000, 1.000000)">
        <path d="M32.86 8.52V1.825a1.826 1.826 0 0 1-1.825 1.825H0V8.52h32.86z" fill="#FF5D7D" />
        <polygon
          fill="#FF764E"
          points="32.8602231 8.51942191 9.12778905e-05 8.51942191 9.12778905e-05 13.3875456 32.8602231 13.3875456 32.8602231 9.73624746"
        />
        <polygon
          fill="#FFC144"
          points="32.8602231 13.3875456 9.12778905e-05 13.3875456 9.12778905e-05 18.2556694 32.8602231 18.2556694 32.8602231 14.6044625"
        />
        <polygon
          fill="#88DF8E"
          points="32.8602231 18.2556694 9.12778905e-05 18.2556694 9.12778905e-05 23.1237931 32.8602231 23.1237931 32.8602231 19.4725862"
        />
        <polygon
          fill="#00CCF2"
          points="32.8602231 23.1237931 9.12778905e-05 23.1237931 9.12778905e-05 27.9919168 32.8602231 27.9919168 32.8602231 24.3407099"
        />
        <path
          d="M32.86 27.992H0v4.868h31.035c1.004 0 1.892-.824 1.825-1.825v-3.043z"
          fill="#B278D3"
        />
        <polygon
          fill="#B278D3"
          points="32.8602231 24.3407099 32.8602231 27.9919168 32.8602231 29.2089249 44.9088134 29.2089249 43.0831643 24.3407099"
        />
        <polygon
          fill="#00CCF2"
          points="32.8602231 24.3407099 43.0831643 24.3407099 41.2576065 19.4725862 32.8602231 19.4725862 32.8602231 23.1237931"
        />
        <polygon
          fill="#88DF8E"
          points="32.8602231 19.4725862 41.2576065 19.4725862 39.4320487 14.6044625 32.8602231 14.6044625 32.8602231 18.2556694"
        />
        <polygon
          fill="#FFC144"
          points="32.8602231 14.6044625 39.4320487 14.6044625 41.2576065 9.73624746 32.8602231 9.73624746 32.8602231 13.3875456"
        />
        <polygon
          fill="#FF764E"
          points="32.8602231 9.73624746 41.2576065 9.73624746 43.0831643 4.86812373 32.8602231 4.86812373 32.8602231 8.51942191"
        />
        <path
          d="M32.86 4.868h10.223L44.91 0H34.686a1.83 1.83 0 0 0-1.826 1.826v3.042z"
          fill="#FF5D7D"
        />
        <path
          d="M5.477 1.826A1.83 1.83 0 0 0 3.65 0a1.83 1.83 0 0 0-1.825 1.826V3.65h3.65V1.826zm0 31.034H1.826v10.223A1.83 1.83 0 0 0 3.65 44.91a1.83 1.83 0 0 0 1.826-1.826V32.86z"
          fill="#C68A65"
        />
      </g>
      <path
        d="M41.554 15.605L46.942 1.24a.918.918 0 0 0-.86-1.24H35.801a2.757 2.757 0 0 0-2.754 2.754.919.919 0 0 1-.918.918H14.688a.918.918 0 1 0 0 1.836h17.441c.322 0 .63-.056.918-.157v3.217H1.836v-3.06h4.59a.918.918 0 0 0 .918-.918V2.754A2.757 2.757 0 0 0 4.59 0a2.757 2.757 0 0 0-2.754 2.754v.918H.918A.918.918 0 0 0 0 4.59v29.375c0 .507.411.918.918.918h.918v9.363A2.757 2.757 0 0 0 4.59 47a2.757 2.757 0 0 0 2.754-2.754v-9.363h24.785c.774 0 1.52-.325 2.05-.89a2.55 2.55 0 0 0 .704-1.891v-.891h11.199a.918.918 0 0 0 .86-1.24l-5.388-14.366zM3.672 2.754a.919.919 0 0 1 1.836 0v.918H3.672v-.918zm38.102 7.038h-6.891v-3.06h8.038l-1.147 3.06zM1.836 20.195h31.211v3.06H1.836v-3.06zm33.047-3.672h5.055l1.147 3.06h-6.202v-3.06zm5.055-1.836h-5.055v-3.06h6.203l-1.148 3.06zm-6.891 3.672H1.836V15.3h31.211v3.06zM1.836 25.091h31.211v3.06H1.836v-3.06zm33.047-3.672h6.89l1.148 3.06h-8.038v-3.06zM35.8 1.836h8.956l-1.147 3.06h-8.727V2.754c0-.506.412-.918.918-.918zm-2.754 8.568v3.06H1.836v-3.06h31.211zM5.507 44.246a.919.919 0 0 1-1.835 0v-9.363h1.836v9.363zM32.84 32.738a.99.99 0 0 1-.71.309H1.836v-3.06h31.211v2.142c0 .02 0 .04.002.061a.729.729 0 0 1-.21.548zm2.044-3.363v-3.06h8.727l1.147 3.06h-9.874z"
        fill="#000"
      />
      <path d="M11 5a1 1 0 0 0 0-2 1 1 0 1 0 0 2z" fill="#000" />
    </g>
  </svg>
)
